"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryString = void 0;
const objects_1 = require("./objects");
exports.queryString = {
    parse(query) {
        return Object.fromEntries(new URLSearchParams(query));
    },
    stringify(object) {
        const params = new URLSearchParams();
        Object
            .entries((0, objects_1.convertKeysToSnakeCase)(object))
            .forEach(([key, value]) => {
            params.append(key, value);
        });
        return params.toString();
    }
};
